module.exports = __webpack_public_path__ + "img/bl.c33c33e.svg";